<template>
  <v-container>
    <div class="task-status">
      <v-row class="my-2">
        <v-col>
          <h2 class="text-no-wrap" v-if="corporation">
            社員タスク：{{ corporation.name }}へのメール送信
          </h2>
        </v-col>
        <v-col class="pl-0 d-flex justify-end align-center">
          <div class="picker-align-right">
            <month-picker
              v-model:selectedDate="selectedDate"
              @on-month-changed="saveSelectedDate"
            />
          </div>
        </v-col>
      </v-row>
      <v-row v-if="monthlyReportMailPostSuccess == false">
        <p class="d-inline font-weight-bold text-red pb-2">
          更新中にエラーが発生しました
        </p>
        <span
          v-if="monthlyReportMailErrors.length != 0"
          class="text-red"
        >
          ({{ monthlyReportMailErrors.join(", ") }})
        </span>
      </v-row>
      <div v-if="monthlyReportMail">
        <monthly-mail-edit v-if="monthlyReportMailEditable" />
        <monthly-mail-view v-else />
      </div>
    </div>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from "vue"
import { useStore } from "../stores/index"
import monthlyMailView from "./shared/MonthlyMailView.vue"
import monthlyMailEdit from "./shared/MonthlyMailEdit.vue"
import monthPicker from "./shared/MonthPicker.vue"

export default defineComponent({
  name: "MonthlyMailPage",
  components: {
    monthlyMailView,
    monthlyMailEdit,
    monthPicker
  },
  setup() {
    const store = useStore()

    // data
    const corporation = computed(() => store.getters.corporation)
    const selectedDate = computed(() => new Date(store.getters.selectedMonthlyReportMailDate))
    const monthlyReportMail = computed(() => store.getters.monthlyReportMail)
    const monthlyReportMailEditable = computed(() => store.getters.monthlyReportMailEditable)
    const monthlyReportMailPostSuccess = computed(() => store.getters.monthlyReportMailPostSuccess)
    const monthlyReportMailErrors = computed(() => store.getters.monthlyReportMailErrors)

    const saveSelectedDate = async (selectedValue: Date) => {
      await store.dispatch("commitSelectedMonthlyReportMailDate", selectedValue)
    }

    onMounted(() => {
      store.dispatch("commitSelectedMonthlyReportMailDate", selectedDate.value)
    })

    return {
      selectedDate,
      monthlyReportMail,
      corporation,
      saveSelectedDate,
      monthlyReportMailEditable,
      monthlyReportMailPostSuccess,
      monthlyReportMailErrors
    }
  }
})
</script>
